import React, {ReactElement} from "react";

import translate from "/src/utils/translate";

import LazyLoadCardLayout, {
  LazyLoadCardLayoutCard,
} from "../layouts/lazy-load-card-layout/LazyLoadCardLayout";
import {CTA} from "../buttons/cta-button/CTAButton";
import {ImageObject} from "../image/Image";

import * as styles from "./cargo-insurance-cards.module.scss";

interface CargoInsuranceCardsProps
  extends Omit<Queries.CargoInsuranceCardsFragmentFragment, "__typename"> {
  path: string;
  id?: string;
}

const CARDS_PER_ROW = 3;

const CargoInsuranceCards = (props: CargoInsuranceCardsProps): ReactElement => {
  const {path, title, cards, id} = props;

  const cardsData = (cards || [])
    .filter(card => card != null)
    .map(card => {
      return {
        eyebrow: card?.cardEyebrow!,
        title: card?.cardTitle!,
        image: card?.cardImage! as ImageObject,
        ctaButtons: [
          {
            ariaLabel:
              card?.cardEyebrow == null
                ? translate("Learn More")
                : translate(`Learn More About "${card?.cardEyebrow}"`),
            label: translate("Learn More"),
            url: `${path}${card?.slug!}`,
          },
          {
            label: card?.cardCta?.label,
            url: card?.cardCta?.url,
            amplitudeCtaName: card?.cardCta?.amplitudeCtaName!,
            amplitudeCtaType: card?.cardCta?.amplitudeCtaType!,
          },
        ] as Array<CTA>,
      };
    });

  const numOfCards = (cardsData || []).length;

  return (
    <LazyLoadCardLayout
      cards={cardsData as Array<LazyLoadCardLayoutCard>}
      headline={title!}
      column="3"
      useCardStyle
      id={id || "cargo-insurance-coverages"}
      cardImageClasses={styles.cargoInsuranceCards__cardImg}
      numVisibleRows={Math.ceil(numOfCards / CARDS_PER_ROW)}
    />
  );
};

export default CargoInsuranceCards;
